import { MODULE_KEYS, type ModuleKey } from './tenant.js';

export const LEVELS = ['none', 'read', 'full'] as const;
export type Level = (typeof LEVELS)[number];

export const LEVEL_LABELS: Record<Level, string> = {
  none: 'No access',
  read: 'Read only',
  full: 'Full access',
};

/** Resources a tenant role grants levels on: the six modules plus management. */
export const TENANT_RESOURCE_KEYS = [...MODULE_KEYS, 'management'] as const;
export type TenantResource = ModuleKey | 'management';

export const MANAGEMENT_RESOURCE = {
  label: 'Management',
  description: 'Invite people, assign groups and roles. Never the superadmin.',
} as const;

/** Resources only DinoCloud staff hold levels on. */
export const STAFF_RESOURCE_KEYS = ['tenants', 'entitle', 'staff', 'audit'] as const;
export type StaffResource = (typeof STAFF_RESOURCE_KEYS)[number];

export type Resource = TenantResource | StaffResource;

export type LevelMap = Record<TenantResource, Level>;

/** A role is a set of levels, one per resource. Nothing lives outside this matrix. */
export interface Role {
  id: string;
  tenantId: string;
  name: string;
  builtIn: boolean;
  description?: string;
  levels: LevelMap;
}

/** A group holds roles. Users belong to groups. */
export interface Group {
  id: string;
  tenantId: string;
  name: string;
  description?: string;
  roleIds: string[];
}
